import { Chip } from "@mui/material";
import * as React from "react";

export type TableCellQualityProps = {
  data: any;
};

const TableCellQuality: React.FC<TableCellQualityProps> = (props) => {
  const value = props.data.value;
  let color: "default" | "info" = "default";

  switch (value) {
    case "4K":
    case "4K HDR":
      color = "info";
      break;
  }

  return <Chip label={value} key={value} size="small" color={color} />;
};

export default TableCellQuality;
